const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')


export function start(detail, htmlDt, htmlFc, client) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc, client)
  }

  detail.html = menuElem
  detail.act = 'show'
  menu.start(detail)

}

const menuBody = {

  trMenu: [

    {
      text: '',
      svg: 'eye',
      class: ``,
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc, client) {
        const dest = client.entity === "clientCustomer" ? "clientSale" : "clientPurchase";
        this.text = 'View'        //language.start('inProgress')     
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"${dest}", "elem":"fullcont", "id":"${dest}-fullcont", "act":"selectOne",  "entity":"${dest}", "dbid": ${detail.dbid} }
           ]}'`

      }
    },

    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail, htmlDt, htmlFc, client) {
        const dest = client.entity === "clientCustomer" ? "clientSale" : "clientPurchase";
        const entity = client.entity === "clientCustomer" ? "sale" : "purchase";
        const reportName = client.entity === "clientCustomer" ? "sale-invoice" : "purchase-invoice";
        this.text = 'Print Order'
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"${dest}", "elem":"fullcont", "entity":"${entity}", "reportName":"${reportName}", "act":"pdfMenuFullcont", "dbid": ${detail.dbid} }
        ]}'`

      }

    },

  ],


  tableOptions: [

    {
      text: '',
      svg: 'print',
      class: ``, //same name as the title test

      dataDetail: '',


      start: function (detail, htmlDt, htmlFc, client) {
        this.text = `Account ${client.entity == 'clientCustomer' ? 'Payable' : 'Receivable'}`,        //language.start('inProgress')     
          this.dataDetail = `
          data-detail='{"click": [
            {"dest":"ripple" },
            {"dest":"menu", "act":"hide"},
            {"dest":"clientActivity", "elem":"report", "reportType":"${client.entity == 'clientCustomer' ? "accountPayable" : "accountReceivable"}"}
          ]}'
        `
      }
    },

  ],

}/*menuBody*/


